module.exports = __webpack_public_path__ + "media/images/tshirt-d8f538b6c42ebb660bd26eb30f7c5cda.svg";